import { useMemo } from 'react'

import { useGetCustomerQuery, useGetTasksQuery } from '../../../../api/plamo-api'
import { Badge, Breadcrumb, Tabs, TabsProps } from 'antd'
import { useNavigate, useParams } from 'react-router-dom'

import { HomeOutlined } from '@ant-design/icons';
import CustomerMainForm from './customer-main-form';
import CustomerAssignment from './customer-assignment';
import styled from 'styled-components';
import CustomerRelatives from './customer-relatives';
import Comments from '../../fragments/comments';
import CustomerBalanceSheet from './customer-balance-sheet';
import CustomerPricing from './customer-pricing';
import CustomerContracts from './customer-contracts';
import CustomerDomesticAid from './customer-domestic-aid';
import CustomerCounseling from './customer-counseling';
import { IconHouseSolid } from '../../../../icon';
import CustomerSettlement from './customer-settlement';
import Tasks from '../../fragments/tasks';
import CustomerDashboard from './customer-dashboard';

const TabsStyled = styled(Tabs)`
  flex: 1;
  overflow: hidden;

  .ant-tabs-content, .ant-tabs-tabpane {
    height: 100%;
    overflow: hidden;
  }
`

function CustomerDetailsPage() {
  const { id, subpage, subsubpage, subsubsubpage } = useParams();
  const customerId = useMemo(() => parseInt(id || "") || undefined, [id])
  const { data: customer } = useGetCustomerQuery({ id }, { skip: id === 'new' }) as { data: any }
  const navigate = useNavigate();
  const { data: openTasks } = useGetTasksQuery({ f: JSON.stringify({ objectType: { c: "EQ", v: "customer" }, objectId: { c: "EQ", v: customerId }, solved: { c: "EQ", v: false } }), st: JSON.stringify({ id: 'desc' }) }) as any

 
  const tabItems: TabsProps['items'] = [
    {
      key: 'dashboard',
      label: 'Dashboard',
      children: <CustomerDashboard customerId={customerId} customer={customer} />,
      disabled: id === 'new'
    },
    {
      key: 'mainForm',
      label: 'Stammdaten',
      children: <CustomerMainForm customerId={customerId} customer={customer} />,
    },
    {
      key: 'tasks',
      label: openTasks?.items?.length ? <Badge count={openTasks?.items?.length || 0}><span style={{ paddingRight: "1em" }}>Todos</span></Badge> : 'Todos',
      children: <Tasks objectId={customerId} objectType="customer" />,
      disabled: id === 'new'
    },
    {
      key: 'assignments',
      label: 'Mitarbeiter',
      children: <CustomerAssignment customerId={customerId} subpage={subsubpage} />,
      disabled: id === 'new'
    },
    {
      key: 'relatives',
      label: 'Angehörige',
      children: <CustomerRelatives customerId={customerId} />,
      disabled: id === 'new'
    },
    ...(
      customer?.domesticAid ? [{
        key: 'domesticAid',
        label: "HKP",
        children: <CustomerDomesticAid customerId={customerId} />,
      }] : []
    ),
    ...(
      customer?.counseling ? [{
        key: 'counseling',
        label: "Beratungsbesuche",
        children: <CustomerCounseling customerId={customerId} />,
      }] : []
    ),
    {
      key: 'balance',
      label: 'Guthaben',
      children: <CustomerBalanceSheet customerId={customerId} customer={customer} />,
      disabled: id === 'new'
    },
    {
      key: 'settlement',
      label: 'Abrechnung',
      children: <CustomerSettlement customerId={customerId} customer={customer} subpage={subsubpage} subSubPage={subsubsubpage} setSubpage={() => {}}  />,
      disabled: id === 'new'
    },
    {
      key: 'pricing',
      label: 'Preisgestaltung',
      children: <CustomerPricing customerId={customerId} />,
      disabled: id === 'new'
    },
    {
      key: 'contracts',
      label: 'Verträge',
      children: <CustomerContracts customer={customer} customerId={customerId} subsubpage={subsubpage} />,
      disabled: id === 'new'
    },
    {
      key: 'comments',
      label: 'Notizen',
      children: <Comments objectId={customerId} objectType="customer" />,
      disabled: id === 'new'
    }
  ];

  return (
    <div style={{ height: "100%", overflow: "scroll", display: 'flex', flexDirection: 'column' }}>
       <Breadcrumb
          style={{ marginBottom: "24px" }}
          items={[
            {
              onClick: () => navigate('/'),
              title: <HomeOutlined />,
            },
            {
              onClick: () => navigate('/customer'),
              title: (
                <>
                  <IconHouseSolid />
                  <span>Kunden</span>
                </>
              ),
            },  
            {
              title: `${customer?.firstName ?? 'unbekannt'} ${customer?.lastName ?? ''}`
            },            
          ]}
        />
      
      <TabsStyled items={tabItems} activeKey={subpage || (id === 'new' ? 'mainForm' : 'dashboard')} onChange={newSubpage => navigate(`/customer/${id}${newSubpage === 'dashboard' ? '' : `/${newSubpage}`}`)} />

    </div>
  )
}

export default CustomerDetailsPage